import { PaystubsYear } from "../paths";
import { getDefaultPaystubsYear, getPaystubsYears } from "../utils";

/**
 * The paystubs dashboard year a pay statement belongs to, for deep-linking into
 * `/member/paystubs/:year/paystub/:paystubId`.
 *
 * The dashboard only offers a fixed set of years, so a `payDate` outside that
 * set — or an absent one, which a statement without a pay date has — falls back
 * to the default year rather than producing a URL the dashboard cannot render.
 */
export const selectorPaystubsYear = (payDate?: Date | null): PaystubsYear => {
  if (!payDate) {
    return getDefaultPaystubsYear();
  }

  const year = String(payDate.getFullYear());

  return getPaystubsYears().includes(year) ? year : getDefaultPaystubsYear();
};
